import { Component, OnInit } from '@angular/core';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-end-user-phone-book-sub-nav',
  templateUrl: './end-user-phone-book-sub-nav.component.html',
  styles: [],
  standalone: false,
})
export class EndUserPhoneBookSubNavComponent extends SubNavBaseComponent implements OnInit {
  ngOnInit() {}
}
